export default "__VITE_ASSET__CJVXTWXL__"